<div class="brand-wrapper">
  <div class="image"></div>
</div>
